const exportComponents = {
  // 模型浏览组件
  ModelView: () => {
    return import('../../../components/model/ModelView')
  },

  /** 工具类 */
  BasicTab: () => {
    return import('../../../components/tool/BaiscTab')
  },
  /** 基础功能 */
  // 模型树
  ModelTree: () => {
    return import('../../../components/basic/ModelTree')
  },

}
export default exportComponents
